<script>
import {mapActions, mapGetters} from 'vuex'
import response from '../../fake/tour-accompagnati-response'
import {SERVER_DATE_FORMAT} from '../../utils/formatter'
import SearchTourAccompagnatiAction from '../actions/SearchTourAccompagnatiAction'
import {FAKE_ACTIVE} from '../../utils/config'
import {PRODUCT_TOUR} from '../../types/products'
import {EMPTY_FLIGHTS_CHECK} from '../../utils/messages'

export default {
  name: 'TourAccompagnatiSearcher',
  mixins: [SearchTourAccompagnatiAction],
  data () {
    return {
      resultMessage: '',
      flightVectorGroupsLoaded: [],
    }
  },
  methods: {
    ...mapGetters(['getTours', 'getSearch']),
    ...mapActions(['addTour', 'addSearch', 'modifyTourOrder', 'modifyTourFilter', 'resetTourFilter']),
    ...mapActions(['loadFlights', 'loadHotels', 'loadTrasferimenti']),
    searchAllTourAccompagnati (data) {
      return FAKE_ACTIVE ? this.searchFake(data) : this.searchReal(data)
    },
    initSearch (data) {
      const search = {product: PRODUCT_TOUR, ...this.getSearch(), ...data.search}
      this.addSearch(search)
    },
    searchReal (data) {
      this.initSearch(data)
      const {tour, search} = data
      const partenza = this.$moment(search.partenza)
      const daysToAdd = this.$store.getters.isGiornoSuccessivoObbligatorio ? tour.detailResponse.detail.days : tour.detailResponse.detail.days - 1
      const ritorno = this.$moment(partenza).add(daysToAdd, 'days')
      const camere = tour.camere ? tour.camere : search.camere
      const payload = {
        aereoporto: data.search.aereoporto,
        partenza: partenza.format(SERVER_DATE_FORMAT),
        ritorno: ritorno.format(SERVER_DATE_FORMAT),
        camere: camere,
        productID: tour.element.productID,
        flight: this.flightFlag(tour),
        transfer: this.transferFlag(tour)
      }
      this.searchTourAccompagnati(payload).then((response) => {
        // const {tourDetailResponses, flightVectorGroups, periodServizi, date, flightDepartureInfo} = response.data.object
        const {tourDetailResponses, flightVectorGroups, periodServizi, date} = response.data.object
        const tourResult = {detailResponses: tourDetailResponses, anagrafica: tour, date}
        this.flightVectorGroupsLoaded = flightVectorGroups
        if (flightVectorGroups) {
          this.loadFlights(flightVectorGroups)
        } else {
          this.resultMessage = EMPTY_FLIGHTS_CHECK
          return
        }
        // if (flightDepartureInfo) this.loadFlightDepartureInfo({...flightDepartureInfo, dateSelected: search.partenza})
        if (periodServizi && periodServizi.length > 0) {
          this.loadTrasferimenti(periodServizi)
        }
        this.addTour(tourResult)
        this.$router.push('/tour')
      }).finally(() => {
        if (this.flightVectorGroupsLoaded) {
          this.$scrollTo('#app')
        } else {
          this.$scrollTo('#partiOra')          
        }
      })
    },
    searchFake (data) {
      this.initSearch(data)
      this.loadingFakeData(data)
      this.$router.push('/tour')
      this.$scrollTo('#app')
    },
    loadingFakeData (data) {
      const {tour} = data
      const {tourDetailResponses, flightVectorGroups, periodServizi, date} = response.object
      const tourResult = {detailResponses: tourDetailResponses, anagrafica: tour, date}
      if (flightVectorGroups) {
        this.loadFlights(flightVectorGroups)
      }
      if (periodServizi && periodServizi.length > 0) {
        // this.loadTrasferimenti(periodServizi)
      }
      this.addTour(tourResult)
    },
    /**
     * volo incluso true: non devo richiedere il volo in tour/record e nel wizard non compaiono le tab voli e neanche i trasferimenti
     * volo incluso false: controllo nel tour restituito dalla call tour/list se il volo è incluso
     * se non lo è, nella call/record richiedo il volo e nel wizard faccio vedere le relative interfacce
     * in questo caso i trasferimenti li chiedo se nel backoffice trasferimento incluso
     * è false e faccio comparire le relative tab
     * @param tour
     * @returns {boolean}
     */
    flightFlag (tour) {
      return !tour.detailResponse.detail.flightIncluded
    },
    transferFlag (tour) {
      const flightFlag = this.flightFlag(tour)
      return flightFlag && tour.isTrasferimento
    },
    adminTour (tour) {
      return this.getTours().list.find(item => {
        return item.codice === tour.detailResponse.detail.productID
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/searcher/TourAccompagnatiSearcher.vue